"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAEAutoComplete = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _styles = require("@material-ui/core/styles");

var _FAEContainer = require("../FAEContainer/FAEContainer");

var _FAEShadowBox = require("../FAEShadowBox/FAEShadowBox");

var _FAEText = require("../FAEText/FAEText");

require("./FAEAutoComplete.scss");

const _excluded = ["placeholder", "className", "justify", "align", "primary", "shadowBoxProps", "renderOption", "values", "value", "label", "type", "getSelectedValue", "isRequired"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)({
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18
    }
  }
});

const FAEAutoComplete = _ref => {
  let {
    placeholder = "placeholder",
    className = "",
    justify,
    align,
    primary,
    shadowBoxProps,
    renderOption,
    values = [],
    value = "",
    label,
    type = "",
    getSelectedValue = () => {},
    isRequired = false
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const classes = useStyles();
  const [selectedValue, setSelectedValue] = (0, _react.useState)({
    label: ""
  });
  (0, _react.useEffect)(() => {
    setSelectedValue(value); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value.label]);

  const handleChange = (e, valueObj) => {
    setSelectedValue(valueObj === null ? {
      label: ""
    } : valueObj);
    getSelectedValue(valueObj === null ? "" : valueObj.value);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FAEContainer.FAEContainer, {
    justify: justify,
    align: align
  }, primary ? /*#__PURE__*/_react.default.createElement(_FAEShadowBox.FAEShadowBox, _extends({}, shadowBoxProps, {
    padding: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--auto-complete-container"
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    important: isRequired && true,
    tertiary: true
  }, label), /*#__PURE__*/_react.default.createElement(_Autocomplete.default, {
    className: className,
    id: "country-select-demo",
    freeSolo: type === "search" && true,
    disableClearable: type === "search" && true,
    options: values,
    classes: {
      option: classes.option
    },
    value: selectedValue,
    autoHighlight: true,
    getOptionLabel: option => option.label,
    filterOptions: option => option,
    onChange: handleChange,
    renderOption: renderOption,
    renderInput: params => /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({}, params, {
      placeholder: placeholder,
      inputProps: _objectSpread(_objectSpread({}, params.inputProps), {}, {
        type: type
      })
    }, rest))
  }))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--auto-complete-container"
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    important: isRequired && true,
    tertiary: true
  }, label), /*#__PURE__*/_react.default.createElement(_Autocomplete.default, {
    className: className,
    id: "country-select-demo",
    freeSolo: type === "search" && true,
    disableClearable: type === "search" && true,
    options: values,
    classes: {
      option: classes.option
    },
    filterOptions: option => option,
    value: selectedValue,
    autoHighlight: true,
    getOptionLabel: option => option.label,
    onChange: handleChange,
    renderOption: renderOption,
    renderInput: params => /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({}, params, {
      placeholder: placeholder,
      variant: "outlined",
      inputProps: _objectSpread(_objectSpread({}, params.inputProps), {}, {
        type: type
      })
    }, rest))
  }))));
};

exports.FAEAutoComplete = FAEAutoComplete;